<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
    >
    <template v-slot:activator="{ on }">
      <v-btn
        color="lighten-2"
        v-on="on"
      >
        Login with username
      </v-btn>
    </template>

    <v-card>
      <form method="post" @submit="startLogin">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Login
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="username"
            label="Username"
            autocomplete="username"
            autocapitalize="none"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
            autocomplete="current-password"
            required
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading"
            type="submit"
          >
            Login
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['api'])
  },
  methods: {
    ...mapActions(['login']),
    startLogin (e) {
      e.preventDefault()
      this.loading = true
      this.login({
        'username': this.username,
        'password': this.password
      }).then(() => {
        this.dialog = false
      }).catch(() => {
        alert('Login failed!')
        this.loading = false
      })
    },
    closeDialog () {
      this.dialog = false
      this.username = ''
      this.password = ''
    }
  }
}
</script>
